import {
  Avatar,
  Box,
  Checkbox,
  Collapse,
  Flex,
  Grid,
  GridItem,
  HStack,
  Heading,
  IconButton,
  Tag,
  Text,
  VStack,
  useDisclosure,
} from "@chakra-ui/react";
import { ChevronDownIcon, ChevronUpIcon } from "@chakra-ui/icons";
import React from "react";

const DeliverableRow = ({ deliverable, onRequirementClick, developers }) => {
  const { isOpen, onToggle } = useDisclosure();
  const { name, status, targetDate, assigned, requirements = [] } = deliverable;

  const assignedDev = developers.find((dev) => dev.name === assigned);

  return (
    <Box borderBottom="1px solid" borderColor="gray.200">
      <Grid
        templateColumns="40px 2fr 1fr 1fr"
        gap={4}
        alignItems="center"
        py={3}
        px={2}
        _hover={{ bg: "gray.50" }}
      >
        <IconButton
          size="sm"
          variant="ghost"
          icon={isOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
          aria-label="Toggle"
          onClick={onToggle}
        />
        <Text fontWeight="medium">{name}</Text>
        <Box>
          <Tag
            colorScheme={
              status === "Completed"
                ? "green"
                : status === "In Progress"
                ? "yellow"
                : "gray"
            }
            whiteSpace="nowrap"
          >
            {status || "Pending"}
          </Tag>
        </Box>
        <HStack spacing={2}>
          <Avatar
            name={assignedDev?.name}
            src={assignedDev?.photoURL}
            size="sm"
          />
          <VStack spacing={0} align="start">
            <Text fontSize="sm">{assignedDev?.name}</Text>
          </VStack>
        </HStack>
      </Grid>

      <Collapse in={isOpen}>
        <Box mx={10} p={4} my={2} bg={"gray.50"}>
          <Text fontWeight="bold" fontSize="sm">
            Requirements:
          </Text>
          <VStack align="start" spacing={2}>
            {requirements.length > 0 ? (
              requirements.map((req) => (
                <Flex key={req.id} align="center" gap={3} w="100%">
                  <Checkbox
                    isChecked={req.completed}
                    isReadOnly
                    colorScheme="green"
                  />
                  <Text
                    fontSize="sm"
                    color={req.completed ? "gray.400" : "gray.700"}
                    textDecoration={req.completed ? "line-through" : "none"}
                    cursor="pointer"
                    onClick={() => onRequirementClick(req)}
                    _hover={{ textDecoration: "underline" }}
                    flex="1"
                  >
                    {req.title}
                  </Text>
                  <Tag
                    size="sm"
                    colorScheme={
                      req.status === "Completed"
                        ? "green"
                        : req.status === "In Progress"
                        ? "yellow"
                        : "gray"
                    }
                  >
                    {req.status}
                  </Tag>
                </Flex>
              ))
            ) : (
              <Text fontSize="sm" color="gray.500">
                No requirements added.
              </Text>
            )}
          </VStack>
        </Box>
      </Collapse>
    </Box>
  );
};

const DeliverableTable = ({ deliverables, onRequirementClick, developers }) => {
  return (
    <Box>
      <Heading size="sm" mb={4}>
        Deliverables
      </Heading>

      {/* Table Header */}
      <Grid
        templateColumns="40px 2fr 1fr 1fr"
        gap={4}
        px={2}
        py={2}
        bg="gray.100"
        fontWeight="bold"
        fontSize="sm"
        borderTopRadius="md"
      >
        <Box /> {/* Toggle button column */}
        <Text>Deliverable</Text>
        <Text>Status</Text>
        <Text>Assigned</Text>
      </Grid>

      {/* Table Rows */}
      <Box border="1px solid" borderColor="gray.200" borderTop="none">
        {deliverables.map((deliverable) => (
          <DeliverableRow
            key={deliverable.id}
            deliverable={deliverable}
            onRequirementClick={onRequirementClick}
            developers={developers}
          />
        ))}
      </Box>
    </Box>
  );
};

export default DeliverableTable;
